<template>
    <e-charts
        :options="chartOptions"
        :init-options="initOptions"
        ref="map"
        autoresize
    />
</template>
<script>
import pieMixin from '@/views/common/m-chart-pie'
import { currency } from '_u/helper'

// 空置率
export default {
    name: 'HomeEmptyRate',
    mixins: [pieMixin],
    props: {
        // 小数
        value: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {}
    },
    computed: {
        chartOptions() {
            return {
                title: {
                    show: true,
                    text: `${currency(this.value * 100, 1)}%`,
                    subtext: `空置率`,
                    itemGap: 0,
                    left: 'center',
                    top: '36%',
                    textStyle: {
                        color: "#2C8DF0",
                    },
                },
                tooltip: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '空置率',
                        type: 'pie',
                        silent: true, // 取消交互效果
                        startAngle: 180,
                        radius: ['70%', '90%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                        },
                        labelLine: {
                            show: false,
                        },
                        data: [
                            {
                                value: parseFloat(this.value.toFixed(1)),
                                name: '空置率',
                            },
                            {
                                value: parseFloat((1 - this.value).toFixed(1)),
                                name: '入住率',
                            },
                        ],
                    },
                ],
                color: ['#2C8DF0', '#F2F2F2'],
            }
        },
    },
    methods: {},
}
</script>
